module.exports = __webpack_public_path__ + "img/chooseup.2d178c98.svg";